import { createTheme } from "@mui/material/styles";

export default function CommonTheme() {

    let theme = createTheme({
        shape: {

        },

        palette: {
            background: {
                paper: '#fff',
            },
            text: {
                primary: '#00463E',
                secondary: '#35B559',
            },
            action: {
                active: '#001E3C',
            },
            primary: {
                main: '#35B559',
                contrastText: '#FFFFFF'
            },
            secondary: {
                main: '#FFFFFF',
                contrastText: '#35B559'
            }
        },

        typography: {
            fontSize: 12,
        },
        components: {

            MuiAccordion: {
                styleOverrides: {
                    root: {
                        marginBottom: "10px",
                        "&:first-of-type": {
                            borderRadius: "0px"
                        },
                        "&.Mui-expanded": {
                            marginTop: '0px'
                        }
                    }
                }
            },
            MuiAccordionSummary: {
                styleOverrides: {
                    content: {
                        fontWeight: 'bold',
                        "&.Mui-expanded": {
                            marginTop: '12px'
                        }
                    }
                }
            },
            MuiButton: {
                styleOverrides: {
                    root: {
                        textTransform: 'none'
                    },
                }
            },
            MuiFab: {
                styleOverrides: {
                    root: {
                        color: '#FFFFFF'
                    }
                }
            },
            MuiFormControlLabel: {
                styleOverrides: {
                    root: {
                        marginLeft: '10px',
                        marginTop: '15px',
                        width: '220px',
                        height: '20px'
                    },
                }
            },
            MuiInputLabel: {
                styleOverrides: {
                    root: {
                        color: '#1976d2', //'#002984',
                        // fontWeight: 'bold',
                        fontSize: '12px',
                        marginTop: '5px',
                        height: '20px',
                        width: '100%'
                    },
                }
            },
            MuiTab: {
                styleOverrides: {
                    root: {
                        bgcolor: 'background.paper',
                        marginLeft: '10px',
                        fontSize: '12px',
                        textAlign: 'center'
                    },
                }
            },
            MuiTabs: {
                styleOverrides: {
                    root: {
                        '.MuiTabs-indicator': {
                            top: '31px',
                            marginLeft: '10px'
                        },
                        height: '34px'
                    },
                }
            },
            MuiTextField: {
                styleOverrides: {
                    root: {
                        height: '15px',
                        width: '220px',
                        lineHeightStep: 1,
                        //fontSize: '13px',
                        marginTop: '5px',
                        marginLeft: '10px',
                        marginRight: '50px',
                        marginBottom: '20px',
                    },

                }
            },
            MuiToggleButton: {
                styleOverrides: {
                    root: {
                        background: '#FFFFFF',
                        borderRadius: '20px',
                        color: '#35B559',
                        fontFamily: 'inherit',
                        textTransform: 'none',
                        border: '0px',
                        "&.Mui-selected": {
                            background: '#35B559',
                            color: '#FFFFFF',
                            zIndex: '2000',
                            "&:hover": {
                                background: '#35B559',
                                color: '#FFFFFF',
                            },
                            "&:not(:first-of-type)": {
                                borderBottomLeftRadius: '20px',
                                borderTopLeftRadius: '20px'
                            },
                            "&:not(:last-of-type)": {
                                borderBottomRightRadius: '20px',
                                borderTopRightRadius: '20px'
                            }
                        }
                    },
                }
            },
            MuiToggleButtonGroup: {
                styleOverrides: {
                    root: {
                        border: '1px solid rgba(0, 0, 0, 0.12)',
                        borderRadius: '20px',
                        boxShadow: '0px 5px 5px grey'
                    }
                }
            },
            MuiTooltip: {
                styleOverrides: {
                    tooltip: {
                        fontSize: '12px'
                    }
                }
            }
        }, // components lopetus
    });

    return theme;
}